"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var BasePortfolioCustomFilterPropertiesImplService = /** @class */ (function () {
    function BasePortfolioCustomFilterPropertiesImplService() {
    }
    BasePortfolioCustomFilterPropertiesImplService.prototype.getFilterWithData = function (category) {
        return undefined;
    };
    /**
     * @param category - category of portfolio
     *
     * @returns keys of custom filters that will be put as field's fieldName.
     */
    BasePortfolioCustomFilterPropertiesImplService.prototype.getCustomFilterKeys = function (category) {
        return Observable_1.Observable.of(category === 'Case' ? ['ejustice_filter_by_order'] : []);
    };
    /**


/**
 * Outer filter - category's filtered by other category that has reference to initial category.
 * E.g. {'isOuterFilter':true, 'Application':['applicationNumber'], fieldNameInParentCategory: 'caseInstanceId'} - filter Case by Application.
 */
    BasePortfolioCustomFilterPropertiesImplService.prototype.getCustomFilterField = function (customFilterFieldKey, category) {
        switch (customFilterFieldKey) {
            case 'ejustice_filter_by_order':
                return Observable_1.Observable.of({ 'isOuterFilter': true, 'Order': ['orderNumber'], fieldNameInParentCategory: 'caseInstanceId' });
        }
        return Observable_1.Observable.of(null);
    };
    return BasePortfolioCustomFilterPropertiesImplService;
}());
exports.BasePortfolioCustomFilterPropertiesImplService = BasePortfolioCustomFilterPropertiesImplService;
//# sourceMappingURL=base-portfolio-custom-filter-properties-impl.service.js.map